var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.0066C2 2.68925 4.68629 0 8 0C11.3137 0 14 2.68925 14 6.0066V7.84096L15.9286 11.9438C16.0379 12.1763 16.0208 12.4488 15.8832 12.6658C15.7457 12.8828 15.5068 13.0143 15.25 13.0143H11.7204C11.6796 13.3196 11.5996 13.6816 11.4466 14.047C11.2494 14.5181 10.9214 15.0176 10.3819 15.3967C9.83835 15.7788 9.13477 16 8.25486 16C7.37452 16 6.67069 15.7786 6.12703 15.3962C5.58752 15.0168 5.25963 14.5169 5.06255 14.0457C4.90781 13.6757 4.82904 13.313 4.78924 13.0143H0.750001C0.493242 13.0143 0.254328 12.8828 0.116752 12.6658C-0.0208246 12.4488 -0.0379398 12.1763 0.0713874 11.9438L2 7.84096V6.0066ZM6.30917 13.0143C6.33921 13.1621 6.38333 13.3182 6.44717 13.4709C6.56258 13.7469 6.73469 13.9943 6.99206 14.1753C7.24528 14.3533 7.63518 14.5055 8.25486 14.5055C8.87425 14.5055 9.26407 14.3535 9.51728 14.1755C9.77462 13.9947 9.94675 13.7475 10.0622 13.4717C10.1271 13.3166 10.1711 13.1599 10.2007 13.0143H6.30917ZM1.93184 11.5126L3.42861 8.3285C3.47563 8.22849 3.5 8.11933 3.5 8.0088V6.0066C3.5 3.51858 5.51472 1.50165 8 1.50165C10.4853 1.50165 12.5 3.51858 12.5 6.0066V8.0088C12.5 8.11933 12.5244 8.22849 12.5714 8.3285L14.0682 11.5126H1.93184Z",
    fill: "#9E9FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.b521c04983e5e6bc865b504b21581efa.svg";
export { ForwardRef as ReactComponent };